import DiningRoomCard from './DiningRoomCard';
import { RestaurantDiningRoomDTO } from '../../../../types/restaurant/RestaurantDiningRoomTypes';

interface DiningRoomGridProps {
  rooms: RestaurantDiningRoomDTO[];
  onEdit: (room: RestaurantDiningRoomDTO) => void;
  onDeactivate: (room: RestaurantDiningRoomDTO) => void;
  onAddTable: (room: RestaurantDiningRoomDTO) => void;
}

const DiningRoomGrid = ({
  rooms,
  onEdit,
  onDeactivate,
  onAddTable,
}: DiningRoomGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:hidden">
      {rooms.map((room) => (
        <DiningRoomCard
          key={room.id}
          room={room}
          onEdit={onEdit}
          onDeactivate={onDeactivate}
          onAddTable={onAddTable}
        />
      ))}
    </div>
  );
};

export default DiningRoomGrid;
